export const hotPicks = [
  {
    id: 'hp-01',
    title: '雾港迷航',
    category: '电影',
    year: '2025',
    region: '内地',
    score: '8.6',
    tags: ['悬疑', '冒险'],
    blurb: '一艘货轮在浓雾中失联，调查员循着航海日志拼回真相。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20foggy%20harbor%20with%20a%20lone%20cargo%20ship%2C%20moody%20warm%20sepia%20tone%2C%20minimal%20graphic%20design%2C%20no%20text%2C%20editorial%20art&width=400&height=600&seq=blueberry-poster-01&orientation=portrait',
  },
  {
    id: 'hp-02',
    title: '长风渡口',
    category: '剧集',
    year: '2025',
    region: '内地',
    score: '8.9',
    tags: ['年代', '群像'],
    blurb: '渡口小城三十年变迁，几代人的聚散与选择。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20riverside%20ferry%20town%20at%20dusk%2C%20warm%20orange%20and%20amber%20tones%2C%20minimal%20graphic%20design%2C%20no%20text%2C%20editorial%20art&width=400&height=600&seq=blueberry-poster-02&orientation=portrait',
  },
  {
    id: 'hp-03',
    title: '星轨旅人',
    category: '动漫',
    year: '2025',
    region: '日本',
    score: '8.4',
    tags: ['科幻', '原创'],
    blurb: '少年在星际列车上看遍不同文明的兴衰。',
    poster:
      'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20of%20a%20spaceship%20train%20traveling%20between%20warm%20golden%20planets%2C%20vivid%20illustration%2C%20no%20text%2C%20editorial%20art&width=400&height=600&seq=blueberry-poster-03&orientation=portrait',
  },
  {
    id: 'hp-04',
    title: '第七个夏天',
    category: '电影',
    year: '2024',
    region: '内地',
    score: '8.1',
    tags: ['青春', '成长'],
    blurb: '毕业那年的海边暑假，改变了四个人的方向。',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20sunlit%20beach%20poster%20with%20silhouettes%20of%20young%20friends%2C%20soft%20peach%20and%20gold%20tones%2C%20minimal%20graphic%20design%2C%20no%20text&width=400&height=600&seq=blueberry-poster-04&orientation=portrait',
  },
  {
    id: 'hp-05',
    title: '周末野餐计划',
    category: '综艺',
    year: '2025',
    region: '内地',
    score: '8.0',
    tags: ['户外', '慢综艺'],
    blurb: '每期换一个郊野营地，边做饭边聊天。',
    poster:
      'https://readdy.ai/api/search-image?query=Cozy%20outdoor%20picnic%20scene%20poster%20with%20wicker%20basket%20and%20blanket%2C%20warm%20terracotta%20and%20cream%20tones%2C%20minimal%20graphic%20design%2C%20no%20text&width=400&height=600&seq=blueberry-poster-05&orientation=portrait',
  },
  {
    id: 'hp-06',
    title: '城中之城·夜航',
    category: '剧集',
    year: '2025',
    region: '内地',
    score: '8.7',
    tags: ['都市', '职场'],
    blurb: '深夜班机上的偶遇，牵出一段城市秘辛。',
    poster:
      'https://readdy.ai/api/search-image?query=Night%20cityscape%20poster%20with%20warm%20window%20lights%2C%20amber%20and%20deep%20brown%20tones%2C%20minimal%20graphic%20design%2C%20no%20text&width=400&height=600&seq=blueberry-poster-06&orientation=portrait',
  },
  {
    id: 'hp-07',
    title: '半城烟火',
    category: '剧集',
    year: '2024',
    region: '内地',
    score: '8.2',
    tags: ['生活', '治愈'],
    blurb: '一条老街的四季，一间小店的日常。',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20old%20street%20poster%20with%20lanterns%20and%20small%20shops%2C%20golden%20hour%20lighting%2C%20minimal%20graphic%20design%2C%20no%20text&width=400&height=600&seq=blueberry-poster-07&orientation=portrait',
  },
  {
    id: 'hp-08',
    title: '蓝莓小镇奇遇',
    category: '动漫',
    year: '2025',
    region: '内地',
    score: '8.3',
    tags: ['合家欢', '冒险'],
    blurb: '小镇少年与一只会说话的蓝莓精灵的历险。',
    poster:
      'https://readdy.ai/api/search-image?query=Playful%20animation%20poster%20of%20a%20cozy%20small%20town%20with%20berry%20fields%2C%20warm%20red%20and%20gold%20palette%2C%20flat%20illustration%2C%20no%20text&width=400&height=600&seq=blueberry-poster-08&orientation=portrait',
  },
  {
    id: 'hp-09',
    title: '山与海的餐桌',
    category: '纪实',
    year: '2025',
    region: '内地',
    score: '8.8',
    tags: ['美食', '人文'],
    blurb: '跟着时令走，从渔港到梯田寻找一口鲜。',
    poster:
      'https://readdy.ai/api/search-image?query=Documentary%20poster%20of%20coastal%20market%20and%20mountain%20terraces%20with%20fresh%20produce%2C%20warm%20earthy%20tones%2C%20no%20text&width=400&height=600&seq=blueberry-poster-09&orientation=portrait',
  },
  {
    id: 'hp-10',
    title: '霓虹之后',
    category: '电影',
    year: '2025',
    region: '港台',
    score: '8.0',
    tags: ['犯罪', '剧情'],
    blurb: '霓虹熄灭的城市凌晨，三个陌生人共享一个秘密。',
    poster:
      'https://readdy.ai/api/search-image?query=Rainy%20neon%20street%20at%20night%20poster%20in%20warm%20red%20and%20amber%20tones%2C%20cinematic%20minimal%20design%2C%20no%20text&width=400&height=600&seq=blueberry-poster-10&orientation=portrait',
  },
  {
    id: 'hp-11',
    title: '一起来做菜吧',
    category: '综艺',
    year: '2024',
    region: '内地',
    score: '7.9',
    tags: ['美食', '互动'],
    blurb: '素人厨房挑战，用最普通的食材做一桌好菜。',
    poster:
      'https://readdy.ai/api/search-image?query=Home%20kitchen%20variety%20show%20poster%20with%20fresh%20vegetables%20and%20pans%2C%20warm%20cream%20and%20rust%20tones%2C%20no%20text&width=400&height=600&seq=blueberry-poster-11&orientation=portrait',
  },
  {
    id: 'hp-12',
    title: '回声谷',
    category: '电影',
    year: '2025',
    region: '欧美',
    score: '7.8',
    tags: ['科幻', '短片集'],
    blurb: '四个关于声音与记忆的独立科幻短篇。',
    poster:
      'https://readdy.ai/api/search-image?query=Abstract%20sci-fi%20short%20film%20poster%20with%20sound%20waves%20and%20canyon%20shapes%2C%20warm%20amber%20and%20deep%20brown%2C%20no%20text&width=400&height=600&seq=blueberry-poster-12&orientation=portrait',
  },
];

export const seriesZone = [
  {
    id: 'sz-01',
    title: '长风渡口',
    episodes: 40,
    latest: 18,
    category: '剧集',
    note: '年代 · 群像 · 每周双更',
  },
  {
    id: 'sz-02',
    title: '城中之城·夜航',
    episodes: 36,
    latest: 36,
    category: '剧集',
    note: '全集完结 · 都市悬疑',
  },
  {
    id: 'sz-03',
    title: '星轨旅人',
    episodes: 24,
    latest: 9,
    category: '动漫',
    note: '科幻 · 原创 · 每周一更',
  },
  {
    id: 'sz-04',
    title: '蓝莓小镇奇遇',
    episodes: 26,
    latest: 24,
    category: '动漫',
    note: '合家欢 · 临近完结',
  },
  {
    id: 'sz-05',
    title: '半城烟火',
    episodes: 32,
    latest: 32,
    category: '剧集',
    note: '全集完结 · 生活治愈',
  },
  {
    id: 'sz-06',
    title: '山与海的餐桌',
    episodes: 12,
    latest: 4,
    category: '纪实',
    note: '美食人文 · 每月更新',
  },
];

export const rankBoard = [
  { id: 'rk-01', rank: 1, title: '长风渡口', category: '剧集', heat: '98.2 万', trend: 'up' },
  { id: 'rk-02', rank: 2, title: '星轨旅人', category: '动漫', heat: '95.7 万', trend: 'up' },
  { id: 'rk-03', rank: 3, title: '雾港迷航', category: '电影', heat: '91.4 万', trend: 'flat' },
  { id: 'rk-04', rank: 4, title: '城中之城·夜航', category: '剧集', heat: '88.9 万', trend: 'down' },
  { id: 'rk-05', rank: 5, title: '山与海的餐桌', category: '纪实', heat: '84.3 万', trend: 'up' },
  { id: 'rk-06', rank: 6, title: '蓝莓小镇奇遇', category: '动漫', heat: '81.6 万', trend: 'up' },
  { id: 'rk-07', rank: 7, title: '周末野餐计划', category: '综艺', heat: '79.1 万', trend: 'flat' },
  { id: 'rk-08', rank: 8, title: '第七个夏天', category: '电影', heat: '76.5 万', trend: 'down' },
  { id: 'rk-09', rank: 9, title: '半城烟火', category: '剧集', heat: '73.8 万', trend: 'up' },
  { id: 'rk-10', rank: 10, title: '回声谷', category: '电影', heat: '70.2 万', trend: 'flat' },
];